export interface SubscriptionState {
  isLoading: boolean;
  list: any[];
  error: string | null;
}

export interface UserState {
  openLogout: boolean;
  userSession: Record<string, any>;
  addAddress: boolean;
  savingNewAddress: boolean;
  verifyEmailResponse: Record<string, any>;
  subscription: SubscriptionState;
  updateEmailResponse: Record<string, any>;
  updatePhoneResponse: Record<string, any>;
  validateOTPResponse: Record<string, any>;
  resendOTPResponse: Record<string, any>;
  loading: boolean;
  loginError: string | null;
  isAuthenticated: boolean;

  // register state
  registerLoading: boolean;
  registerError: string | null;
  registerSuccessMessage: string | null;
  registerSuccess: boolean;
}

export enum UserActionTypes {
  LOGIN_REQUEST = "user/loginRequest",
  LOGIN_SUCCESS = "user/loginSuccess",
  LOGIN_FAILURE = "user/loginFailure",

  LOGOUT = "user/logout",

  FETCH_SESSION_REQUEST = "user/fetchSessionRequest",
  FETCH_SESSION_SUCCESS = "user/fetchSessionSuccess",
  FETCH_SESSION_FAILURE = "user/fetchSessionFailure",

  REGISTER_REQUEST = "user/REGISTER_REQUEST",
  REGISTER_SUCCESS = "user/REGISTER_SUCCESS",
  REGISTER_FAILURE = "user/REGISTER_FAILURE",

}
